
export const ROLE = {
  ADMIN: "Admin", //CAP "Admin"
  GROUP_ADMIN: "GroupAdmin", // CAP "GroupAdmin"
  STUDIO: "Studio", //CAP "Studio"
  OPERATOR: "Operator", //CAP "Operator"
  USER: "User", // CAP null
};


export const filterRoles = (items, role, subRole, disabled = false) => {
  if (!items) return [];

  // Escludi sempre GROUP_ADMIN dai profili
  if (disabled) {
    items = items.filter(
      (r) => r.capabilities?.every((cap) => cap.description !== ROLE.GROUP_ADMIN)
    );
  }

  // Se sei ADMIN SENZA subRole -> vedi tutti i profili
  if (role === ROLE.ADMIN && !subRole) {
    return items;
  }

  // Se sei ADMIN MA hai subRole -> escludi i ruoli che hanno capability "Admin"
  if (role === ROLE.ADMIN && subRole) {
    return items.filter(
      (r) => !r.capabilities?.some((cap) => cap.description === ROLE.ADMIN)
    );
  }

  // Se sei STUDIO -> escludi i ruoli con capability "Admin" e "Studio"
  if (role === ROLE.STUDIO) {
    return items.filter(
      (r) =>
        !r.capabilities?.some(
          (cap) =>
            cap.description === ROLE.ADMIN ||
            cap.description === ROLE.GROUP_ADMIN ||
            cap.description === ROLE.STUDIO
        )
    );
  }

  return items;
};

